import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeActionTypeWidgetInnerCtaButtonParts = uiPartCreateNamespacedParts('DoppeActionTypeWidgetInnerCtaButtonParts', {
    Root: 'Root',
})

export function doppeActionTypeWidgetInnerCtaButtonPartsCreateName(actionId: string, name?: string) {
    return `${actionId}-${name ?? 'default'}`;

}